import type { InterestZoneRun, InterestZoneRunWithUrl } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const fetchInterestZoneRuns = async (): Promise<InterestZoneRun[]> => {
  const { data } = await gozokiApiWithAuth.get<InterestZoneRun[]>('/interest-zone-runs')
  return data
}

export const fetchInterestZoneRun = async (key: string): Promise<InterestZoneRunWithUrl> => {
  const { data } = await gozokiApiWithAuth.get<InterestZoneRunWithUrl>(`/interest-zone-runs/${key}`)
  return data
}
